import React, { FC } from 'react';
import classNames from 'classnames';
import { Asset, InfoFilledIcon, WarningIcon } from '@clearcover/atlas';
import { ReportMessageIncidentType } from '../ReportMessages';
import styles from './styles.module.css';

export type ReportMessagePropsType = {
  reportType: ReportMessageIncidentType;
  messageType:
    | 'report-failure'
    | 'product-toggle'
    | 'rate-change'
    | 'downpay-change'
    | 'fullpay-change';
  className?: string;
  children?: React.ReactNode;
};

export const ReportMessage: FC<ReportMessagePropsType> = ({
  reportType,
  messageType,
  className,
  children,
}) => {
  const isError =
    messageType === 'report-failure' || messageType === 'product-toggle';
  return (
    <div
      className={classNames(
        styles.message,
        { [styles.error]: isError },
        className
      )}
      data-testid={`${reportType}-${messageType}-message`}
    >
      <Asset
        className={styles.messageIcon}
        icon={isError ? WarningIcon : InfoFilledIcon}
        height={16}
        width={16}
        description={isError ? 'warning' : 'info'}
      />
      {children}
    </div>
  );
};
